import React, { Component} from "react";
// Styles
// import "./ProcLevelView.scss";


// Components
import HeaderView from "components/HeaderView";
// import Next from 'static/img/next.svg'
import  Tutorial2 from "views/Tutorial2/Tutorial2";

class RunAllView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      < Tutorial2>
      </Tutorial2>
    </div>
      </>
    );
  }
}
export default RunAllView;
